module.exports = __webpack_public_path__ + "img/ue4.bc5e6058.png";